/* VisionPêche — défilement automatique du carrousel « Nos lunettes ».
   Le thème ne propose pas cette option. On fait défiler la piste elle-même
   plutôt que de simuler un clic sur la flèche, dont le gestionnaire n'est pas
   toujours actif. S'arrête au survol, au focus clavier, quand l'onglet passe
   en arrière-plan, et si l'utilisateur a demandé moins d'animations. */
(function () {
  var DELAI = 4000;

  function demarrer(slider) {
    var piste = slider.querySelector('.slider');
    if (!piste) return;

    var minuteur = null;
    var enPause = false;

    function pas() {
      var carte = piste.querySelector('.grid__item');
      if (!carte) return 0;
      var ecart = parseFloat(getComputedStyle(piste).columnGap) || 0;
      return carte.getBoundingClientRect().width + ecart;
    }

    function avancer() {
      if (enPause || document.hidden) return;
      var reste = piste.scrollWidth - piste.clientWidth - piste.scrollLeft;
      if (reste <= 4) {
        piste.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        piste.scrollBy({ left: pas(), behavior: 'smooth' });
      }
    }

    function lancer() { if (!minuteur) minuteur = setInterval(avancer, DELAI); }
    function arreter() { clearInterval(minuteur); minuteur = null; }

    ['mouseenter', 'focusin'].forEach(function (e) {
      slider.addEventListener(e, function () { enPause = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (e) {
      slider.addEventListener(e, function () { enPause = false; }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) arreter(); else lancer();
    });

    lancer();
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[id$="__collection_vedette"] slider-component').forEach(demarrer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
